import { render, staticRenderFns } from "./register-teacher.vue?vue&type=template&id=43dabae9&"
import script from "./register-teacher.vue?vue&type=script&lang=js&"
export * from "./register-teacher.vue?vue&type=script&lang=js&"
import style0 from "./register-teacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports